export default __webpack_public_path__ + "static/media/21.638a973a.png";